const env = process.env.REACT_APP_ENV || 'development';

const commonConfig = {
  redirectAfterFinishTime: 5000,
  associatesTag: 'mealwell-21',
};

const config = require(`./${env}`).default;
Object.assign(config, commonConfig);

module.exports = config;